import { useState, useEffect } from 'react';
import { api } from './supabase';
import LumenSistema from './LumenSistema';

export default function App() {
  const [pronto, setPronto] = useState(false);
  const [erro, setErro] = useState(null);
  const [dados, setDados] = useState(null);

  useEffect(() => {
    carregarTudo();
  }, []);

  const carregarTudo = async () => {
    try {
      const [especialistas, clientes, visitas, marcos, tarefas, dmgData, tiposProjeto, prospects, consultores, dpsData] = await Promise.all([
        api.especialistas.list(),
        api.clientes.list(),
        api.visitas.list(),
        api.marcos.list(),
        api.tarefas.list(),
        api.dmg.list(),
        api.tiposProjeto.list(),
        api.prospects.list(),
        api.consultores.list(),
        api.dps.list(),
      ]);
      setDados({ especialistas, clientes, visitas, marcos, tarefas, dmgData, tiposProjeto, prospects, consultores, dpsData });
      setPronto(true);
    } catch (e) {
      console.error(e);
      setErro(e.message);
    }
  };

  if (erro) return (
    <div style={{ minHeight: '100vh', background: '#0A1628', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#E8F4FF', fontFamily: 'system-ui', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 32 }}>⚠️</div>
      <div style={{ fontSize: 16, fontWeight: 700 }}>Erro ao conectar ao banco de dados</div>
      <div style={{ fontSize: 13, color: '#6A90B8', maxWidth: 400, textAlign: 'center' }}>{erro}</div>
      <div style={{ fontSize: 12, color: '#6A90B8' }}>Verifique se as variáveis REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY estão configuradas no .env.local</div>
      <button onClick={carregarTudo} style={{ padding: '10px 20px', background: '#F44D19', border: 'none', borderRadius: 8, color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Tentar novamente</button>
    </div>
  );

  if (!pronto) return (
    <div style={{ minHeight: '100vh', background: '#0A1628', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16, fontFamily: 'system-ui' }}>
      <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid #1C3550', borderTop: '3px solid #F44D19', animation: 'spin 0.8s linear infinite' }} />
      <div style={{ color: '#6A90B8', fontSize: 13 }}>Conectando ao Lumen...</div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return <LumenSistema dadosIniciais={dados} api={api} />;
}
